export const randomize = (): string =>
  Math.floor(Math.random() * 1e11).toString(36);
